import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    num: '1',
    title: 'TOMO 1 — Consulta sin Perder Tiempo',
    quote: '“Cómo resolver una consulta sin trabarte”',
    bullets: ['qué mirar primero', 'qué ignorar', 'cómo detectar rápido el problema principal', 'cómo decidir en minutos'],
    includes: 'Checklist de primera consulta + Hoja de ruta de evaluación rápida'
  }, {
    num: '2',
    title: 'TOMO 2 — Cómo explicarle al paciente',
    subtitle: '(y cómo adaptarlo sin empezar de cero)',
    quote: '“Guiones + estructura para indicar con claridad”',
    bullets: ['qué indicar según el caso', 'cómo simplificar', 'cómo no repetir siempre lo mismo'],
    includes: 'Guiones listos + Matriz de adaptación por perfil de paciente'
  }, {
    num: '3',
    title: 'TOMO 3 — Patologías Frecuentes',
    subtitle: 'Resolución Rápida en Consulta',
    quote: '“Qué hacer en consulta (paso a paso)”',
    bullets: ['diabetes', 'obesidad', 'hipertensión'],
    includes: 'Protocolos + objetivos por etapa + errores comunes + señales de alarma (clínicas)'
  }, {
    num: '4',
    title: 'TOMO 4 — Pacientes Estancados',
    subtitle: '(cuando no avanza)',
    quote: '“Qué hacer cuando el paciente no baja / no cumple / no mejora”',
    bullets: ['checklist de estancamiento', 'árbol de decisiones (qué ajustar primero)', 'guiones para reencuadre y adherencia'],
    includes: 'Este tomo es oro: te devuelve el control en las consultas difíciles.',
    highlight: true
  }, {
    num: '5',
    title: 'TOMO 5 — Decisiones Clínicas Reales',
    subtitle: '(Lo que Nadie Te Enseña)',
    quote: '“Cómo pensar como pro en situaciones reales”',
    bullets: ['escenarios reales de consultorio', 'errores típicos y cómo evitarlos', 'reglas de criterio para decidir más rápido y mejor'],
    includes: 'Casos guiados + "qué harías si…" + reglas de oro'
  }];
  return <section className="pt-6 pb-12 bg-black" data-id="element-299">
      <div className="max-w-4xl mx-auto px-4" data-id="element-300">
        <FadeIn className="text-center mb-10" data-id="element-301">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-mint mb-4" data-id="element-302">
            LO QUE RECIBÍS
          </h2>
          <p className="text-xl font-medium text-mint/70 flex items-center justify-center gap-2" data-id="element-303">
            LOS 5 TOMOS (Megapack Nutri Pro Listo)
          </p>
        </FadeIn>

        <div className="space-y-6" data-id="element-304">
          {tomos.map((tomo, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-305">
              <div className="bg-surface rounded-2xl p-6 md:p-8 border-l-8 border-mint shadow-sm hover:shadow-md transition-shadow" data-id="element-306">
                <div className="flex items-start gap-4 mb-4" data-id="element-307">
                  <span className="text-2xl font-display font-bold text-mint mt-1" data-id="element-308">
                    {tomo.num}.
                  </span>
                  <div data-id="element-309">
                    <h3 className="font-bold text-xl md:text-2xl text-mint" data-id="element-310">
                      {tomo.title}
                    </h3>
                    {tomo.subtitle && <p className="text-lg text-mint/70 font-medium" data-id="element-311">
                        {tomo.subtitle}
                      </p>}
                  </div>
                </div>

                <div className="ml-10" data-id="element-312">
                  <div className="inline-block bg-mint/10 text-mint px-3 py-1 rounded text-sm font-bold mb-3" data-id="element-313">
                    💣 {tomo.quote}
                  </div>

                  <ul className="space-y-2 mb-4" data-id="element-314">
                    {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-white/80" data-id="element-315">
                        <Check size={18} className="text-mint mt-0.5 shrink-0" data-id="element-316" />
                        <span data-id="element-317">{bullet}</span>
                      </li>)}
                  </ul>

                  <div className={`p-4 rounded-lg border ${tomo.highlight ? 'bg-mint/15 border-mint/30' : 'bg-mint/10 border-mint/20'}`} data-id="element-318">
                    <p className="font-medium text-mint text-sm md:text-base" data-id="element-319">
                      <span className="font-bold" data-id="element-320">Incluye:</span>{' '}
                      {tomo.includes}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}